<template>
    <div>
        <div class="nav_header">
            <h2>创建发票或者收据信息</h2>
        </div>

        <template v-if="form.invoice_status==1||form.invoice_status===2">
            <el-alert v-if="form.invoice_status==1" :closable="false" title="当前的发票信息正在审核中，无法进行修改" type="info"></el-alert>

            <el-alert v-if="form.invoice_status===2" :closable="false" title="当前的发票信息已经通过审核，如需修改，请联系客服" type="info"></el-alert>
            <white-space />
        </template>

        <el-form label-width="150px" :model="form">
            <el-form-item label="发票类型">
                <el-radio-group v-model="form.invoice_type" :disabled="readonly">
                    <el-radio label="receipt" :disabled="readonly">收据（免费）</el-radio>
                    <el-radio label="normal" :disabled="readonly">增值税普通发票（6%税点）</el-radio>
                    <el-radio label="special" :disabled="readonly">增值税专用发票（6%税点）</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="发票抬头" v-if="form.invoice_type=='normal' || form.invoice_type=='special'">
                <el-input class="form-input" :readonly="readonly" v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="收据抬头" v-if="form.invoice_type=='receipt'">
                <el-input class="form-input" :readonly="readonly" v-model="form.title"></el-input>
            </el-form-item>

            <!--
      <el-form-item label="发票明细">
        <el-input class="form-input"></el-input>
      </el-form-item>
      -->
            <el-form-item label="纳税人识别号" v-if="form.invoice_type=='normal' || form.invoice_type=='special'">
                <el-input class="form-input" v-model="form.id_code" :readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="地址" v-if="form.invoice_type=='special'">
                <el-input class="form-input" v-model="form.reg_address" :readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="公司电话">
                <el-input class="form-input" v-model="form.tel" :readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="开户行" v-if="form.invoice_type=='special'">
                <el-input class="form-input" v-model="form.public_bank_name" :readonly="readonly"></el-input>
            </el-form-item>

            <el-form-item label="开户行账号" v-if="form.invoice_type=='special'">
                <el-input class="form-input" v-model="form.public_bank_no" :readonly="readonly"></el-input>
            </el-form-item>
            
            <el-form-item label="营业执照" v-if="form.invoice_type=='normal' || form.invoice_type=='special'" style="overflow: hidden;">
                <el-upload :disabled="readonly" :action="action" :with-credentials="true" list-type="picture-card"
                    :show-file-list="false" :file-list="fileList" :on-success="handleImageSuccess" :on-remove="handleRemove">
                    <img v-if="form.license" :src="form.license" class="avatar">
                    <i v-else class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>

            <el-form-item v-if="form.invoice_status!=1&&form.invoice_status!=2">
                <el-button type="primary" @click="onSubmit" :loading="submitting">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<style scoped>
</style>
<script>
    import {
        baseURL
    } from "../../plugins/http/index";
    export default {
        data() {
            return {
                extraContent: "",
                order_no: "",
                importVisible: false,
                submitting: false,
                readonly: true,
                fileList: [],
                form: {
                    invoice_type: "",
                    invoice_status: 1
                }
            };
        },
        computed: {
            mode() {
                return this.$route.meta._meta;
            },
            action() {
                return baseURL + "service/uploader";
            },
            headers() {
                return {
                    "x-identity": "advertiser"
                };
            }
        },
        watch: {
            "form.invoice_status"(v) {
                this.readonly = !!(v == 1 || v == 2);
            },
            "form.license"(v) {
                if (v) {
                    this.fileList = [{
                        name: "营业执照",
                        url: v
                    }];
                }
            }
        },
        created() {
            this.load();
        },
        methods: {
            load() {
                this.$http.get(`personal/invoice`).then(res => {
                    if (res.success) {
                        this.form = res.data;
                    }
                });
            },
            handleImageSuccess(response) {
                if (response.success) {
                    this.form.license = response.data.url;
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file, fileList) {
                this.fileList = [];
                this.form.license = "";
            },
            onSubmit() {
                this.submitting = true;
                this.$http
                    .post(`personal/invoice`, this.form)
                    .then(response => {
                        if (response.success) {
                            return this.$router.push("/finance/invoice");
                        } else {
                            this.$alert(response.message, "失败", {
                                type: "error"
                            });
                        }
                    })
                    .catch()
                    .then(function () {
                        this.submitting = false;
                    });
            }
        }
    };

</script>
